import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { DropdownButton, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

var _ = require('underscore');
import * as clientActions from 'redux/modules/clients';

import { resetFilter } from 'redux/modules/supervision';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
	state => ({}),
	dispatch => bindActionCreators({ ...clientActions, resetFilter }, dispatch)
)
export default class ConsultMenu extends Component {	

	render() {
		const {t} = this.props
		var client = this.props.client;
		var title = <span><i className="fa fa-eye" aria-hidden="true"> </i> {this.props.label}</span>
		return (
			<DropdownButton pullRight style={{ fontSize: "14px", lineHeight: '3px', fontWeight: 'normal', height: '33px' }} bsStyle="warning" bsSize={'sm'} title={title} id="bg-vertical-dropdown-1">

				{/*
  		  <LinkContainer to={"/admin/fiches/"+client}>
    	  	<MenuItem eventKey="1">Fiches</MenuItem>
    	  </LinkContainer>*/}

				<LinkContainer to={"/admin/products/" + client}>
					<MenuItem eventKey="3">{t('main.products')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/users/" + client}>
					<MenuItem eventKey="4">{t('main.users')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/groups/" + client}>
					<MenuItem eventKey="5">{t('main.groups')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/supervision/" + client} onClick={() => this.props.resetFilter()}>
					<MenuItem eventKey="6">{t('main.supervision')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/supervisionErrors/" + client}>
					<MenuItem eventKey="6">{t('main.anomalies')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/tickets/" + client}>
					<MenuItem eventKey="7">{t('main.tickets')}</MenuItem>
				</LinkContainer>

				<LinkContainer to={"/admin/LastEventsView/" + client}>
					<MenuItem eventKey="8">{t('main.last_events')}</MenuItem>
				</LinkContainer>

				<MenuItem divider />

				<LinkContainer to={"/admin/dashboardView/" + client}>
					<MenuItem eventKey="8">{t('main.dashboard')}</MenuItem>
				</LinkContainer>


				<MenuItem divider />
				<LinkContainer to={"/admin/clientList/"}>
					<MenuItem eventKey="9">{t('main.clientlist')}</MenuItem>
				</LinkContainer>

				<MenuItem divider />

				<LinkContainer to={"/admin/timelineEvents/" + client}>
					<MenuItem eventKey="10">{t('main.module_01')}</MenuItem>
				</LinkContainer>

			</DropdownButton>
		);
	}
} 